export function getCategory(data) {
    let { getCategoryRequest, getCategoryError, getCategoryResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/category/get_category',
        this.createBundle('app/category/get_category', { id: data }, this.GET, getCategoryRequest, getCategoryResult, getCategoryError)
    )
}
